export interface ChartColors {
  panel: string;
  text: string;
  muted: string;
  border: string;
  accent: string;
  up: string;
  down: string;
  /** Set by themes with a chart of its own look (the classic black chart); absent, the chart follows the panels. */
  chartBg?: string;
  barUp?: string;
  barDown?: string;
  bullBody?: string;
  bearBody?: string;
  line?: string;
  bid?: string;
  ask?: string;
  /** The grid is dotted (the classic look) instead of faint solid lines. */
  gridDotted?: boolean;
}

/** Reads the active theme from the CSS variables, so the chart follows theme changes like everything else. */
export function readChartColors(el: HTMLElement): ChartColors {
  const css = getComputedStyle(el);
  const v = (name: string, fallback: string) => css.getPropertyValue(name).trim() || fallback;
  const chart = (name: string) => css.getPropertyValue(`--chart-${name}`).trim() || undefined;
  const bg = chart('bg');
  if (bg) {
    // A chart with its own colours: every chart colour comes from the theme's chart tokens.
    const text = chart('text') ?? v('--text', '#ffffff');
    return {
      panel: bg,
      text,
      muted: text,
      border: chart('grid') ?? v('--border', '#555555'),
      accent: v('--accent', '#ff4fa3'),
      up: chart('up') ?? v('--up', '#34e0a1'),
      down: chart('down') ?? v('--down', '#ff6b7f'),
      chartBg: bg,
      barUp: chart('bar-up'),
      barDown: chart('bar-down'),
      bullBody: chart('bull-body'),
      bearBody: chart('bear-body'),
      line: chart('line'),
      bid: chart('bid'),
      ask: chart('ask'),
      gridDotted: true,
    };
  }
  return {
    panel: v('--panel', '#140f27'),
    text: v('--text', '#efeaff'),
    muted: v('--muted', '#a79fd0'),
    border: v('--border', '#31275a'),
    accent: v('--accent', '#ff4fa3'),
    up: v('--up', '#34e0a1'),
    down: v('--down', '#ff6b7f'),
  };
}
